import React from 'react'

import { StyledButtonGroup } from '~/components/elements/StyledButtonGroup'

import {
  ToggleRadioButton,
  type ToggleRadioButtonProps,
} from './components/ToggleRadioButton'

export type ToggleRadioButtonGroupProps<T extends string> = {
  attributes: ToggleRadioButtonProps<T>['attribute'][]
  'data-testid'?: string
  disabled?: boolean
  onChange?: (value: T) => void
  value: T | undefined
}

export const ToggleRadioButtonGroup = <T extends string>({
  attributes,
  'data-testid': dataTestId = 'components-elements-toggle-radio-button-group',
  disabled,
  onChange,
  value,
}: ToggleRadioButtonGroupProps<T>) => (
  <StyledButtonGroup data-testid={dataTestId}>
    {attributes.map((attribute) => (
      <ToggleRadioButton
        key={attribute.value}
        attribute={attribute}
        disabled={disabled}
        selected={attribute.value === value}
        onChange={onChange}
      />
    ))}
  </StyledButtonGroup>
)
